import * as React from 'react';
import {ButtonGroupView} from './ButtonGroupView';
import {ButtonGroupItem} from './ButtonGroupItem';
import {useButtonGroup} from './useButtonGroup';
import {type ButtonGroupProps} from './ButtonGroup.types';

/**
 * # ButtonGroup
 *
 * ButtonGroup is a control that groups selectable options for users. The options are rendered as inline `Button` elements.
 *
 * ## Usage
 *
 * ```jsx
 * import React from 'react';
 * import ButtonGroup from '@packages/design-system/ButtonGroup';
 *
 * const options = [
 *   {value: 'one', label: 'One'},
 *   {value: 'two', label: 'Two'},
 *   {value: 'three', label: 'Three'},
 * ];
 *
 * function Example() {
 *   const [value, setValue] = React.useState('one');
 *
 *   return <ButtonGroup value={value} onChange={setValue} options={options} />;
 * }
 * ```
 *
 * @deprecated use `SegmentedControl` from `@packages/systems/spring` instead
 */
export const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  (props, ref) => {
    const {
      options = [],
      getItemProps,
      ...rest
    } = useButtonGroup({
      ...props,
      ref,
    });

    return (
      // @ts-expect-error - TS2769 - No overload matches this call.
      <ButtonGroupView data-legacy-ds="ButtonGroup" {...rest}>
        {options.map((item, index) => {
          return (
            <ButtonGroupItem
              {...getItemProps({item, index})}
              key={`button-group-option-${item.value}`}
            />
          );
        })}
      </ButtonGroupView>
    );
  }
);

export default ButtonGroup;
